export const generateHtmlSections = (clientId: string, planName: string) => {
    const isPremium = planName.toLowerCase() === 'premium';

    const styles = isPremium ? premiumStyles : standardStyles;
    const htmlMarkup = isPremium ? premiumHtml : standardHtml;
    const scriptIncludes = isPremium ? premiumScripts : standardScripts;
    const scriptLogic = isPremium ? getPremiumScriptLogic(clientId) : getStandardScriptLogic(clientId);

    const fullCode = `${styles}\n\n${htmlMarkup}\n\n${scriptIncludes}\n\n${scriptLogic}`;

    return {
        Styles: styles,
        HTML: htmlMarkup,
        'Script Includes': scriptIncludes,
        'Script Logic': scriptLogic,
        Full: fullCode,
    };
};

// ========== Premium Templates ==========

const premiumStyles = `
<link rel="stylesheet" href="https://d2agdzfzghaish.cloudfront.net/membership/index.css" />
<link rel="stylesheet" href="https://d2agdzfzghaish.cloudfront.net/media/index.css" />
`.trim();

const premiumHtml = `
<div id="cembooClientJoinNowButton"></div>
<div id="cemboo-media-library"></div>
`.trim();

const premiumScripts = `
<script src="https://d2agdzfzghaish.cloudfront.net/membership/index.js"></script>
<script src="https://d2agdzfzghaish.cloudfront.net/media/index.js"></script>
`.trim();

const getPremiumScriptLogic = (clientId: string) => `
<script>
const clientId = "${clientId}";
window.onload = () => {
    initiateCembooMembershipLibrary(clientId);
    const CembooMediaLibrary = new window.CembooMediaLibrary(clientId, 'false', true, true);
    const cembooMediaLibrary = CembooMediaLibrary.init();
};
const initiateCembooMembershipLibrary = (clientId) => {
    const CembooMembershipLibrary = new window.CembooMemberSpace(clientId);
    CembooMembershipLibrary.init();
};
</script>
`.trim();

// ========== Standard Templates ==========

const standardStyles = `
<link rel="stylesheet" href="https://d2agdzfzghaish.cloudfront.net/membership/index.css" />
<link rel="stylesheet" href="https://d2agdzfzghaish.cloudfront.net/stream/index.css" />
<link rel="stylesheet" href="https://d2agdzfzghaish.cloudfront.net/media/index.css" />
`.trim();

const standardHtml = `
<div id="cembooClientJoinNowButton"></div>
<div id="cemboo-stream-library"></div>
<div id="cemboo-media-library"></div>
`.trim();

const standardScripts = `
<script src="https://d2agdzfzghaish.cloudfront.net/membership/index.js"></script>
<script src="https://d2agdzfzghaish.cloudfront.net/stream/index.js"></script>
<script src="https://d2agdzfzghaish.cloudfront.net/media/index.js"></script>
`.trim();

const getStandardScriptLogic = (clientId: string) => `
<script>
const clientId = "${clientId}";
window.onload = () => {
    initiateCembooMemberSpace();
    initiateCembooStreamLibrary();
    const CembooMediaLibrary = new window.CembooMediaLibrary(clientId, "false", true, true);
    const cembooMediaLibrary = CembooMediaLibrary.init();
};
const initiateCembooMemberSpace = () => {
    new window.CembooMemberSpace(clientId).init();
};
const initiateCembooStreamLibrary = () => {
    new window.CembooStreamLibrary(clientId).init();
};
</script>
`.trim();
